import streamSaver from 'streamsaver'
import { saveAs as fileSaverSaveAs } from 'file-saver'

const checkServiceWorkersRegistration = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!('serviceWorker' in navigator)) {
      reject()
    }

    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) {
        resolve()
      }

      reject()
    }).catch(() => {
      reject()
    })
  })
}

export function saveAs(blob: Blob, name: string): Promise<void> {
  return checkServiceWorkersRegistration().then(() => {
    const fileStream = streamSaver.createWriteStream(name, {
      size: blob.size,
    })
    const readableStream = blob.stream()
    if (window.WritableStream && readableStream.pipeTo) {
      return readableStream.pipeTo(fileStream)
    }
    const writer = fileStream.getWriter()
    ;(window as any).writer = writer
    const reader = readableStream.getReader()
    const pump = (): Promise<void> => {
      return reader.read()
        .then(res => res.done
          ? writer.close()
          : writer.write(res.value).then(pump))
    }

    return pump()
  }).catch(() => {
    return fileSaverSaveAs(blob, name)
  })
}
